<div class="loading-overlay">
  <div class="d-flex flex-column align-items-center">
    <div class="lottie-wrapper">
      <ng-lottie [options]="options"></ng-lottie>
    </div>
    <p
      class="text-white fw-semibold"
      style="margin-top: clamp(-40px, -5vw, -20px)"
    >
      {{ message }}
    </p>
  </div>
</div>
